import { render, staticRenderFns } from "./BoardBasisKey.vue?vue&type=template&id=a5e7e2d0&"
import script from "./BoardBasisKey.vue?vue&type=script&lang=js&"
export * from "./BoardBasisKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5e7e2d0')) {
      api.createRecord('a5e7e2d0', component.options)
    } else {
      api.reload('a5e7e2d0', component.options)
    }
    module.hot.accept("./BoardBasisKey.vue?vue&type=template&id=a5e7e2d0&", function () {
      api.rerender('a5e7e2d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/BoardBasisKey.vue"
export default component.exports